import classes from "../classes";
import findBet from "../find-bet";
import { Map } from "immutable";
import PlayFieldRaceEntrant from "./play-field-race-entrant";
import PlayFieldRaceHeader from "./play-field-race-header";
import React from "react";
import selectPage from "../select-page";
import { trackEvent } from "../analytics";

export default class PlayFieldRace extends React.PureComponent {

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    var { expandedRace, gameBoardToggleRace, race } = this.props;
    gameBoardToggleRace(race.get("id"));
    var expanded = race.get("id") === expandedRace;
    if (!expanded) {
      trackEvent("Game Board", "expand_race", race.get("track_name") + "-" + race.get("race_number"), race.get("id"));
    }
  }

  render() {
    var { bets, expandedRace, myTickets, onMakeAlternatePick, onMakePick, page, pageSize, number, race, raceEntrants, survivors, tickets, tournament, users } = this.props;

    var cancellationReason = (race.get("cancellation_reason") || "").trim();

    var expanded = race.get("id") === expandedRace;

    var details;
    if (expanded) {
      details = (
        <RaceDetails
          bets={bets}
          myTickets={myTickets}
          number={number}
          onMakeAlternatePick={onMakeAlternatePick}
          onMakePick={onMakePick}
          page={page}
          pageSize={pageSize}
          race={race}
          raceEntrants={raceEntrants}
          survivors={survivors}
          tickets={tickets}
          tournament={tournament}
          users={users} />
      );
    }

    return (
      <div
        className={classes({
          "tooltip": cancellationReason.length > 0,
          "tournament-table": true,
          "tournament-table--is-cancelled": race.get("status") === "cancelled",
          "tournament-table--is-open": expanded
        })}
        data-tooltip={cancellationReason}
        onClick={this.toggle}>
        <PlayFieldRaceHeader
          bets={bets}
          myTickets={myTickets}
          number={number}
          page={page}
          pageSize={pageSize}
          race={race}
          raceEntrants={raceEntrants}
          survivors={survivors}
          tickets={tickets}
          tournament={tournament}
          users={users} />

        {details}
      </div>
    );
  }
}

class RaceDetails extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { pendingPicks: Map(), savedPicks: Map() };
    this.makePick = this.makePick.bind(this);
    this.makeAlternatePick = this.makeAlternatePick.bind(this);
  }

  // This might be able to be mostly converted to getDerivedStateFromProps to save some re-renders
  // but after doing major version upgrades of Webpack/Babel/ESLint, I don't have the energy to tackle it
  componentDidUpdate(prevProps) {
    var nextProps = this.props;
    var { bets, race } = prevProps;
    var { pendingPicks, savedPicks } = this.state;
    pendingPicks.forEach((_, ticketId) => {
      var oldBet = findBet(bets, race.get("id"), ticketId);
      var nextBet = findBet(nextProps.bets, nextProps.race.get("id"), ticketId);
      if (oldBet === undefined && nextBet !== undefined || (
        oldBet !== undefined && nextBet !== undefined && (
          oldBet.get("race_entrant_id") !== nextBet.get("race_entrant_id") ||
          oldBet.get("alternate_pick_id") !== nextBet.get("alternate_pick_id")
        )
      )) {
        var raceEntrantId = pendingPicks.get(ticketId);
        this.setState({ // eslint-disable-line react/no-set-state
          pendingPicks: pendingPicks.delete(ticketId),
          savedPicks: savedPicks.set(ticketId, raceEntrantId)
        });
        window.setTimeout(this.finishSaveAnimation.bind(this, ticketId), 1500);
      }
    });
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  finishSaveAnimation(ticketId) {
    if (this.unmounted) {
      return;
    }
    var { savedPicks } = this.state;
    this.setState({ // eslint-disable-line react/no-set-state
      savedPicks: savedPicks.delete(ticketId)
    });
  }

  makePick(ticketId, tournamentId, raceId, raceEntrantId, alternatePickId) {
    var { onMakePick } = this.props;
    var { pendingPicks } = this.state;
    this.setState({ pendingPicks: pendingPicks.set(ticketId, raceEntrantId) }); // eslint-disable-line react/no-set-state
    onMakePick(ticketId, tournamentId, raceId, raceEntrantId, alternatePickId);
  }

  makeAlternatePick(ticketId, tournamentId, raceId, raceEntrantId, alternatePickId) {
    var { onMakeAlternatePick } = this.props;
    var { pendingPicks } = this.state;
    this.setState({ pendingPicks: pendingPicks.set(ticketId, alternatePickId) }); // eslint-disable-line react/no-set-state
    onMakeAlternatePick(ticketId, tournamentId, raceId, raceEntrantId, alternatePickId);
  }

  render() {
    var { bets, myTickets, page, pageSize, race, raceEntrants, tickets, tournament, users } = this.props;
    var { pendingPicks, savedPicks } = this.state;

    var entrants = race.get("race_entrants")
      .map(entrantId => raceEntrants.get(entrantId))
      .filter(entrant => entrant)
      .sort((a, b) => a.get("lane_number") - b.get("lane_number"))
      .map((entrant) => (
        <PlayFieldRaceEntrant
          bets={bets}
          key={entrant.get("id")}
          myTickets={myTickets}
          onMakeAlternatePick={this.makeAlternatePick}
          onMakePick={this.makePick}
          page={page}
          pageSize={pageSize}
          pendingPicks={pendingPicks}
          race={race}
          raceEntrant={entrant}
          raceEntrants={raceEntrants}
          savedPicks={savedPicks}
          tickets={tickets}
          tournament={tournament}
          users={users} />
      ));

    var prevPage = null;
    var nextPage = null;
    if (myTickets.size > pageSize) {
      prevPage = (
        <div className="game-table_cell game-table_cell--nav" />
      );
      nextPage = (
        <div className="game-table_cell game-table_cell--nav" />
      );
    }
    var pickColumnLabel;
    if (tournament.get("status") !== "open") {
      pickColumnLabel = "Player Pick Statistics";
    }

    var jockeyLabel = "Jockey";
    var runnerLabel = "Horse";

    if (race.get("track_breed_type") === "Harness") {
      jockeyLabel = "Driver";
    } else if (race.get("track_breed_type") === "Greyhound") {
      jockeyLabel = "";
      runnerLabel = "Greyhound";
    }

    return (
      <div className="tournament-table_row tournament-table_row--details">
        <div className="game-table">
          <div className="game-table_row game-table_row--header game-table_row--header-alt">
            <div className="game-table_cell game-table_cell--horse-name">
              {runnerLabel}
            </div>

            <div className="game-table_cell game-table_cell--horse-odds">
              ML
            </div>

            <div className="game-table_cell game-table_cell--horse-jockey">
              {jockeyLabel}
            </div>

            <div className="game-table_cell game-table_cell--horse-trainer">
              Trainer
            </div>

            <div className="game-table_cell game-table_cell--player-picks">
              {pickColumnLabel}
            </div>

            {prevPage}

            {selectPage(myTickets, page, pageSize).map((ticket) => <div className="game-table_cell game-table_cell--ticket" key={ticket.get("id")} />)}

            {nextPage}
          </div>

          {entrants}
        </div>
      </div>
    );
  }
}
